import React from "react";

// import SearchBar from "./SearchBar";
// import VendorQuickActions from "./VendorQuickActions";


const VendorAppBar = () => {
  return (
    <div className="flex flex-grow items-center justify-center gap-2">
      {/* <VendorQuickActions /> */}

      {/* <SearchBar /> */}
    </div>
  );
};

export default VendorAppBar;
